import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("canvas", { id: "canvas" }, null, -1)
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "URL", -1)
const _hoisted_5 = ["value"]

import {  onMounted } from 'vue';
import CoreDialog from '../../../framework/components/dialog/CoreDialog.vue';
import QRCode from 'qrcode';
import { SessionUser } from '../../utils/SessionUser';
import { useRoute } from 'vue-router';
import { ContentsUrl } from '../../utils/ContentsUrl';
import { DialogHandler } from './DialogHandler';
import { translation } from '../../lang/Translation';

/**
 * 動的ラベル
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'QrCodeDialog',
  setup(__props) {

const t = translation;
const title = t.to('QRコード',"qr_code");
/**
 * プロパティ
 */
const route = useRoute();
const project_id = route.params.project_id as string;
const dialogId = DialogHandler.qrDialogId;
// URL
const url = ContentsUrl.instance.getUrl(project_id, SessionUser.instance.userId);

/**
 * マウント時にキャンバスを取得してQRを描画
 */
onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, function () {
    const canvas = document.getElementById('canvas');
    if (!canvas) return;
    QRCode.toCanvas(canvas, url,  (error) => {
      if (error) console.error(error);
      canvas.setAttribute('style', 'width:400px;height:400px');
    });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CoreDialog, {
      id: _unref(dialogId),
      title: _unref(title)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("input", {
              type: "text",
              value: _unref(url),
              class: "form-control w-100"
            }, null, 8, _hoisted_5)
          ])
        ])
      ]),
      _: 1
    }, 8, ["id", "title"])
  ]))
}
}

})